import { FunctionComponent } from 'react'
import { Box } from '@black-bear-energy/rucksack'
import { SiteRFPPhaseAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { FilterListRounded } from '@mui/icons-material'
import { FilterMenuItem } from '../common/FilterMenuItem'
import { MenuAlign, MenuButton } from '../common/MenuButton'
import { MenuButtonSection } from '../common/MenuButtonSection'
import { getSiteRFPPhaseDisplayName } from '../helpers/DocumentExchange/getSiteRFPPhaseDisplayName'

export const FilterButton: FunctionComponent<FilterButtonProps> = ({
  requiredMissing,
  setRequiredMissing,
  reviewMissing,
  setReviewMissing,
  phase,
  setPhase,
  handleReset,
  resetDisabled,
  align = 'left',
}) => {
  const filterCount =
    (requiredMissing ? 1 : 0) + (reviewMissing ? 1 : 0) + phase.length
  const label = filterCount === 0 ? 'filters' : `filters (${filterCount})`
  // Site RFPs with phase 'PreRFP' and 'RFP' are not shown in the table.
  // 'DeriskingAndPermits' is not its own filter option, it is instead
  // represented by the 'Derisking' and 'Permits' filter options.
  const phaseFilterOptions = [
    SiteRFPPhaseAPIResponse.Contracts,
    SiteRFPPhaseAPIResponse.Derisking,
    SiteRFPPhaseAPIResponse.Permits,
    SiteRFPPhaseAPIResponse.NTP,
    SiteRFPPhaseAPIResponse.PreCon,
    SiteRFPPhaseAPIResponse.Construction,
    SiteRFPPhaseAPIResponse.Complete,
  ]

  const handleRequiredMissingChange = () => {
    setRequiredMissing(!requiredMissing)
  }
  const handleReviewMissingChange = () => {
    setReviewMissing(!reviewMissing)
  }
  const handlePhaseItemChange = (phaseParam: SiteRFPPhaseAPIResponse) => {
    if (phase.includes(phaseParam)) {
      setPhase(phase.filter((deletedPhase) => deletedPhase !== phaseParam))
    } else {
      setPhase([...phase, phaseParam])
    }
  }

  return (
    <MenuButton
      label={label}
      icon={<FilterListRounded />}
      align={align}
      reset={{ handleReset, resetDisabled }}
      menuSx={{ maxHeight: '400px', overflowY: 'scroll' }}
    >
      <Box component="li" sx={{ paddingY: 1 }}>
        <MenuButtonSection title="Document Status">
          <FilterMenuItem
            label="Required Documents Needed"
            checked={requiredMissing}
            onChange={handleRequiredMissingChange}
          />
          <FilterMenuItem
            label="Documents Pending Review"
            checked={reviewMissing}
            onChange={handleReviewMissingChange}
          />
        </MenuButtonSection>
        <MenuButtonSection title="Site Phase">
          {phaseFilterOptions.map((phaseParam) => (
            <FilterMenuItem
              key={phaseParam}
              label={getSiteRFPPhaseDisplayName(phaseParam)}
              checked={phase.includes(phaseParam)}
              onChange={() => handlePhaseItemChange(phaseParam)}
            />
          ))}
        </MenuButtonSection>
      </Box>
    </MenuButton>
  )
}

export interface FilterButtonProps {
  requiredMissing: boolean
  setRequiredMissing: (requiredMissing: boolean) => void
  reviewMissing: boolean
  setReviewMissing: (reviewMissing: boolean) => void
  phase: SiteRFPPhaseAPIResponse[]
  setPhase: (phase: SiteRFPPhaseAPIResponse[]) => void
  handleReset: () => void
  resetDisabled: boolean
  align?: MenuAlign
}
